"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = extractPlayablesFromConfig;
var _uriToUrl = _interopRequireDefault(require("../utils/uriToUrl"));
var _extractBoundariesFromSrc = _interopRequireDefault(require("../utils/extractBoundariesFromSrc"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Extracts the playables in the correct shape from config:
 *   startOffsetMs {number}
 *   durationMs {number}
 *
 * @param {{startTime: ?number, endTime: ?number, src: string, skipToTime: ?number}[]} Array of playable shapes
 * @param {Object} window.location
 * @param {function} function for mapping the playable's ads
 * @param {string} name of key for ads in the return object, defaults to 'ads'
 * @param {string} name of key for video source in the return object, defaults to 'src'

 *
 * @return {{startTime: number, endTime: number, src: string}[]} Array of stabilized playables
 */
function extractPlayablesFromConfig() {
  var playables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var location = arguments.length > 1 ? arguments[1] : undefined;
  var adExtractor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var adsKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ads';
  var srcKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'src';
  return playables.map(function (_ref) {
    var _boundaries$endTime, _boundaries$startTime;
    var ads = _ref.ads,
      endTime = _ref.endTime,
      src = _ref.src,
      startTime = _ref.startTime,
      poster = _ref.poster,
      skipToTime = _ref.skipToTime,
      dynamicSeekingEdgeState = _ref.dynamicSeekingEdgeState,
      isDynamic = _ref.isDynamic,
      skipCurrentTimeUpdatesBetweenConsecutivePlayables = _ref.skipCurrentTimeUpdatesBetweenConsecutivePlayables,
      selectedAngleName = _ref.selectedAngleName,
      name = _ref.name;
    var boundaries = (0, _extractBoundariesFromSrc["default"])(src);
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, adsKey, adExtractor(ads)), "endTime", (_boundaries$endTime = boundaries.endTime) !== null && _boundaries$endTime !== void 0 ? _boundaries$endTime : endTime), srcKey, (0, _uriToUrl["default"])(src, location || window.location)), "skipToTime", skipToTime), "dynamicSeekingEdgeState", dynamicSeekingEdgeState), "isDynamic", isDynamic), "skipCurrentTimeUpdatesBetweenConsecutivePlayables", skipCurrentTimeUpdatesBetweenConsecutivePlayables), "startTime", (_boundaries$startTime = boundaries.startTime) !== null && _boundaries$startTime !== void 0 ? _boundaries$startTime : startTime), "poster", (0, _uriToUrl["default"])(poster, location)), "selectedAngleName", selectedAngleName !== null && selectedAngleName !== void 0 ? selectedAngleName : name);
  });
}